import React from 'react';
import { Message } from 'types';
import ChatMessage from './ChatMessage';
import classes from '../index.module.scss';

/**
 * Props interface for the ChatMessages component
 */
interface Props {
	/** Array of message objects to display */
	messages: Message[];
	/** Current user ID to determine message alignment */
	userId: number;
}

/**
 * ChatMessages component
 * Renders a list of chat messages with proper alignment based on sender
 * Displays each message using the ChatMessage component
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ChatMessages = ({ messages, userId }: Props) => (
	<div className={classes['chatPopup-chatMessages']}>
		{/* Map through messages and render each one */}
		{messages.map((message) => (
			<ChatMessage
				key={message.id}
				chat={message}
				// Determine if the current user is the sender of this message
				isSender={String(userId) === String(message.userId)}
			/>
		))}
		{/* Commented out loading indicator */}
		{/* <div className={classes['chatPopup-loadingIndicator']}>
			<div />
			<div />
			<div />
		</div> */}
	</div>
);

export default ChatMessages;
